/************************************************************
 Task namespace
 ************************************************************/

window.taskNS = {
    _action:null,
    _callback:null,
    _row:null,
    openTaskDetailsModal: function (task_id, task_type_id, wf_id, episode_id) {
        Hades.showLoading();

        var params = {
            task_id: task_id,
            task_type_id: task_type_id,
            wf_id: wf_id,
            episode_id: episode_id
        };

        $.get('/tasks/details_modal', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    }
};